import * as React from "react";
import "./MaxDistanceInput.scss";
import NumberInput from "../commons/components/form/input/NumberInput";
import { required } from "../commons/model/form/Validators";
import SelectInput from "../commons/components/form/input/SelectInput";
import Option from "../commons/model/Option";
import TextAction from "../commons/components/action/TextAction";
import { useEffect, useRef, useState } from "react";
import { Distance, DistanceUnit } from "../commons/model/address/Distance";

interface MaxDistanceInputProps {
  value?: Distance;
  defaultDistance: Distance;
  onValueChange: (newDistance: Distance) => void;
}

const options = [
  new Option(
    DistanceUnit.KILOMETERS.toString(),
    i18n["Page.Settings.VirtualConsultation.Customization.Form.MaximumDistance.Unit.Km"]
  ),
  new Option(
    DistanceUnit.MILES.toString(),
    i18n["Page.Settings.VirtualConsultation.Customization.Form.MaximumDistance.Unit.Miles"]
  ),
];

const MaxDistanceInput = (props: MaxDistanceInputProps) => {
  const [distance, setDistance] = useState<Distance>(props.value || props.defaultDistance);
  const selectRef = useRef(null);

  useEffect(() => {
    props.onValueChange(distance);
  }, [distance]);

  useEffect(() => {
    setDistance(props.value || props.defaultDistance);
  }, [props]);

  const handleRestDefault = () => {
    setDistance(props.defaultDistance);
    if (selectRef && selectRef.current) {
      selectRef.current.reset(props.defaultDistance.unit.toString());
    }
  };

  const handleValueChange = (e) => {
    setDistance({ ...distance, value: e.value });
  };

  const handleUnitChange = (e) => {
    setDistance({ ...distance, unit: e.value as DistanceUnit });
  };

  return (
    <div className="h-flex">
      <div className="distance-input">
        <NumberInput
          name="max-practice-search-distance"
          value={distance.value}
          validators={[required()]}
          onChange={handleValueChange}
        />
      </div>
      <div className="distance-input">
        <SelectInput
          ref={selectRef}
          options={options}
          initialValue={distance.unit.toString()}
          name="max_distance_unit"
          onChange={handleUnitChange}
        />
      </div>
      <TextAction
        icon="ic_restore"
        label={"Reset default"}
        additionalClass="is-centered-vertically"
        onClick={handleRestDefault}
      />
    </div>
  );
};

export default MaxDistanceInput;
